import React, { createContext, useContext, useState, ReactNode } from 'react';

interface TooltipContextType {
  isTooltipOpen: boolean;
  setIsTooltipOpen: (open: boolean) => void;
}

const TooltipContext = createContext<TooltipContextType | undefined>(undefined);

export const useTooltip = () => {
  const context = useContext(TooltipContext);
  if (context === undefined) {
    throw new Error('useTooltip must be used within a TooltipProvider');
  }
  return context;
};

interface TooltipProviderProps {
  children: ReactNode;
}

export const TooltipProvider: React.FC<TooltipProviderProps> = ({ children }) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <TooltipContext.Provider value={{ isTooltipOpen, setIsTooltipOpen }}>
      {children}
    </TooltipContext.Provider>
  );
};




















